import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { analytics } from "@/lib/analytics";

export function useNewsletterSubscribe() {
  const [loading, setLoading] = useState(false);

  const subscribe = async (email: string) => {
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("newsletter-subscribe", {
        body: { email },
      });
      if (error) throw error;
      toast.success("You're subscribed! Welcome aboard.");
      analytics.newsletterSignup();
      return true;
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { subscribe, loading };
}
